<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <register-member
        :member="localMember"
        :ask-for-email="true"
        :main-member="member.main === true"
        ref="memberForm"
    />

    <div class="coq-modal__footer">
      <b-button disabled variant="primary" style="width: 100%">
        <template v-if="loading">
          <font-awesome-icon icon="spinner" spin/>
        </template>
        <template v-else>
          <template v-if="member.id">
            Confirmer les modifications
          </template>
          <template v-else>
            Ajouter le nouveau membre
          </template>
        </template>
      </b-button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import RegisterMember from '../Inscription/Inscription_Membre';
  import _ from 'lodash';

  export default {
    name: 'member-add-or-edit-v2',
    components: { RegisterMember },
    props: {
      member: {
        type: Object
      }
    },
    data() {
      return {
        localMember: {
          newsletter: true
        },
        loading: false
      };
    },
    beforeMount() {
      this.localMember = _.cloneDeep(this.member);
    },
    methods: {
      ...mapActions('members', {
        updateMember: 'update',
        addMember: 'add'
      }),
      async saveMember() {
        // Validate form
        this.$refs.memberForm.$v.member.$touch();
        if (!this.$refs.memberForm.check()) {
          return;
        }
        if (this.loading === false) {
          this.loading = true;
          // Execute update
          if (this.member.id && !_.isEmpty(this.member.id)) {
            try {
              await this.updateMember({
                id: this.member.id,
                memberInfo: _.cloneDeep(this.localMember)
              });
              this.$emit('close');
              this.$swal.fire({
                text: 'Le membre a été mis à jour',
                type: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              });
            }
            catch (e) {
              this.loading = false;
              console.error('Failed to update member', e);
              this.$swal.fire({
                title: 'Erreur',
                text: 'Une erreur s\'est produite lors de la mise à jour.',
                type: 'error'
              });
            }
          }
          else {
            try {
              await this.addMember({ memberInfo: _.cloneDeep(this.localMember) });
              this.$emit('close');
              this.$swal.fire({
                text: 'Le membre a été ajouté',
                type: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              });
            }
            catch (e) {
              this.loading = false;
              console.error('Failed to add member', e);
              this.$swal.fire({
                title: 'Erreur',
                text: 'Une erreur s\'est produite lors de la création du membre.',
                type: 'error'
              });
            }
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
